<script lang="ts" setup>
defineProps<{
  text?: string;
}>();
</script>
<template>
  <div v-if="text" class="horizontal-separator">
    <span>{{ text }}</span>
  </div>
  <!-- ENG-20665 native separator (replaces the Quasar separator) -->
  <hr v-else class="m-separator" />
</template>
<style lang="scss">
.m-separator {
  height: 1px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.12);
}
.horizontal-separator {
  display: flex;
  flex-direction: row;
  color: var(--grey-darkest);

  span {
    margin-left: 20px;
    margin-right: 20px;
  }

  &:before,
  &:after {
    content: " ";
    flex: 1 1;
    border: 1px solid var(--grey-light);
    margin: auto;
  }
}
</style>
